import { render, staticRenderFns } from "./popupConfirm.vue?vue&type=template&id=30820278&scoped=true"
import script from "./popupConfirm.vue?vue&type=script&lang=js"
export * from "./popupConfirm.vue?vue&type=script&lang=js"
import style0 from "./popupConfirm.vue?vue&type=style&index=0&id=30820278&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30820278",
  null
  
)

export default component.exports